/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'visitors',
        title: 'Visitors',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/visitors'
    },
    {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:banknotes',
        children: [
            {
                id: 'transaction.income',
                title: 'Income',
                type: 'basic',
                icon: 'heroicons_outline:currency-rupee',
                link: '/transactions/income'
            },
            {
                id: 'transaction.expenses',
                title: 'Expenses',
                type: 'basic',
                icon: 'heroicons_outline:credit-card',
                link: '/transactions/expenses'
            }
        ]
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'complaints',
        title: 'Complaints',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left-ellipsis',
        link : '/complaints'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'visitors',
        title: 'Visitors',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/visitors'
    },
    {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:banknotes',
        children: []
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'complaints',
        title: 'Complaints',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left-ellipsis',
        link : '/complaints'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'visitors',
        title: 'Visitors',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/visitors'
    },
    {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:banknotes',
        children: []
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'complaints',
        title: 'Complaints',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left-ellipsis',
        link : '/complaints'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'visitors',
        title: 'Visitors',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/visitors'
    },
    {
        id: 'transaction',
        title: 'Transactions',
        type: 'group',
        icon: 'heroicons_outline:banknotes',
        children: []
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'complaints',
        title: 'Complaints',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left-ellipsis',
        link : '/complaints'
    }
];
